<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm3"></a></p>
<div class="fmhT"><i><b>Prologue</b></i></div>
<div class="fmtx1"><i>FOR A LONG TIME, I thought this story began with my daughter’s birth, or just a few hours later, when we learned that she might not hear. But the question of not hearing began long before her, before me.</i></div>
<div class="fmtx"><i>A string, fragile and thin, a cilia strand, a helix, twists its way back in time to Brooklyn, New York, and before that, to tiny shtetls, specks on the maps of Eastern Europe. For generations, the line has been frayed and tattered.</i></div>
<div class="fmtx"><i>But I am told that at one time, a cord gently linked our wrists so that we would wake together. Our hands clasped and our arms twined, thick as a seaman’s rope.</i></div>
<div class="fmtx"><i>And we could hear.</i></div>
<div class="fmtx"><i>And we could listen.</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// jenn_9781558616912_oeb_fm3_r1.vue?5208d4ca